import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const STORAGE = "adc_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, variant = null) => {
    const key = variant ? variant.sku : product.id;
    const price = variant ? variant.price : product.price;
    const image = variant
      ? (product.images || [])[variant.image_index] || (product.images || [])[0] || ""
      : (product.images || [])[0] || "";
    const variantLabel = variant ? `${variant.color} · ${variant.chocolate_type} Chocolate` : "";
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + quantity } : i));
      }
      return [...prev, {
        key,
        product_id: product.id,
        variant_sku: variant ? variant.sku : null,
        name: product.name,
        variant_label: variantLabel,
        price,
        image,
        quantity,
      }];
    });
    setOpen(true);
    if (window.fbq) window.fbq("track", "AddToCart", { content_name: product.name, value: price, currency: "USD" });
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const updateQty = (key, quantity) => {
    if (quantity < 1) return removeItem(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity } : i)));
  };
  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.quantity, 0);
  const subtotal = items.reduce((a, i) => a + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
